import { DestroyRef, Injectable, inject, signal } from '@angular/core';
import { getApiUrl } from './http-client';
import { enterMaintenance, maintenanceActive, maintenanceGeneration, maintenanceReturnPath } from './maintenance-state';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  readonly active = maintenanceActive;
  readonly ready = signal(false);
  readonly checking = signal(false);
  readonly error = signal('');
  private pending?: Promise<void>;

  constructor() {
    const timer = window.setInterval(() => { void this.check(); }, 60_000);
    inject(DestroyRef).onDestroy(() => window.clearInterval(timer));
  }

  check(): Promise<void> {
    if (this.pending) return this.pending;
    this.checking.set(true);
    const generation = maintenanceGeneration();
    this.pending = (async () => {
      try {
        const response = await fetch(getApiUrl('/api/maintenance?ngsw-bypass=true'), {
          credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(10_000),
        });
        if (!response.ok) throw new Error('status unavailable');
        const status = await response.json();
        if (typeof status.enabled !== 'boolean') throw new Error('invalid status');
        // A business request may have detected maintenance while this check was in flight.
        if (generation !== maintenanceGeneration()) return;
        this.error.set('');
        if (status.enabled) enterMaintenance();
        else if (this.active()) {
          // Fresh read-only navigation; never replay a request or clear session storage/cookies.
          const target = maintenanceReturnPath();
          const current = window.location.pathname + window.location.search + window.location.hash;
          if (target && target !== current) window.location.replace(window.location.origin + target);
          else window.location.reload();
          return;
        }
        this.ready.set(true);
      } catch {
        this.error.set('No se pudo comprobar la disponibilidad. Vuelve a intentarlo en unos instantes.');
      } finally {
        this.checking.set(false);
        this.pending = undefined;
      }
    })();
    return this.pending;
  }
}
